<!-- 首页-banner轮播图模块 -->
<template>
  <div class="home-banner-content">
    <div class="swiper-container" @mouseover="onMouseOver" @mouseleave="onMouseLeave">
      <div class="swiper-wrapper">
        <!-- 图片遍历 -->
        <div class="swiper-slide" v-for="(item, index) in homeBannerImage" :key="index">
          <div class="banner-wrap">
            <img
              class="banner-bg"
              :src="item.imageUrl"
              alt
            />

            <div class="banner-content-box" v-if="item.h5ButtonText === '了解更多'">
              <div class="banner-content-title">人工智能引领的教育新变革</div>
              <div class="special-effects">
                <ul class="ul-left">
                  <li :class="[leftIndex >= index ? 'li-hover-left' : '']" v-for="index in 20" :key="index"></li>
                </ul>
                <span>打造符合职业教育特点的人工智能通识教育体系</span>
                <ul class="ul-right">
                  <li :class="[rightIndex >= index ? 'li-hover-right' : '']" v-for="index in 20" :key="index"></li>
                </ul>
              </div>
              <ul class="banner-content-ul">
                <span class="line"></span>
                <li>
                  <i class="icon-ellipse icon-ellipse-one"></i>
                  <span>人工智能通</span>
                  <span>识课程体系</span>
                  <span>及平台</span>
                </li>
                <span class="line"></span>
                <li>
                  <i class="icon-ellipse icon-ellipse-two"></i>
                  <span>人工智能</span>
                  <span>实训体系</span>
                </li>
                <span class="line"></span>
                <li>
                  <i class="icon-ellipse icon-ellipse-three"></i>
                  <span>人工智能</span>
                  <span>师资培训</span>
                  <span>体系</span>
                </li>
                <span class="line"></span>
                <li>
                  <i class="icon-ellipse icon-ellipse-four"></i>
                  <span>配套增值</span>
                  <span>服务</span>
                </li>
                <span class="line"></span>
              </ul>
            </div>
            
            <div class="popover-button">
              <el-popover
                placement="top"
                trigger="hover"
                width="200"
                v-if="item.h5ButtonText"
                @mouseover="onMouseOver"
              >
                <img :src="item.h5CodeUrl" @mouseover="onMouseOver" />
                <p class="scanCodeTips" @mouseover="onMouseOver">扫码了解更多方案详情</p>
                <span
                  slot="reference"
                  id="more-button'"
                  :class="[item.h5ButtonText === '了解赛事' ? 'match-button':'more-button']"
                  @click="onLearnAboutTheEvent(item.matchUrl)"
                  >{{item.h5ButtonText}}<i class="el-icon-arrow-right"></i
                ></span>
              </el-popover>
            </div>
          </div>
        </div>
      </div>

      <div class="swiper-pagination" slot="pagination"></div>
      <!-- 如果需要导航按钮 -->
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
      <!-- 如果需要滚动条 -->
      <!--      <div class="swiper-scrollbar"></div>-->
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'
import 'swiper/css/swiper.min.css'
     /* eslint-disable */ 
    let tag= process.env.VUE_APP_TAG
    let homeBannerImage=getEnv(tag).homeBannerImage
export default {
  name: 'gtaBannerSwiper',
  components: {},

  data() {
    return {
      homeBannerImage: homeBannerImage,
      homeSwiperImage: [
        {
          imageUrl: require('../../../public/images/home/banner01.png'),
          h5CodeUrl: '',
          h5ButtonText: '',
          matchUrl: '',
        },
        {
          imageUrl: require('../../../public/images/home/banner02.png'),
          h5CodeUrl: require('../../../public/images/home/h5-code.png'),
          h5ButtonText: '了解更多',
          matchUrl: '',
        },
        {
          imageUrl: require('../../../public/images/home/banner03.png'),
          h5CodeUrl: require('../../../public/images/home/h5-code.png'),
          h5ButtonText: '了解赛事',
          matchUrl: '',
        }
      ],
      leftIndex: 0,
      rightIndex: 0,
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.initSwiper() // 轮播图Swiper配置
    this.animationEffect() // 箭头动画效果
  },
  methods: {
    // 轮播图Swiper配置
    initSwiper() {
      this.swiper = new Swiper(".swiper-container", {
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        // autoplay: false,
        observer: true, // 当改变swiper样式或修改swiper的子元素时，自动初始化swiper，
        observerParents: true,
        effect: 'fade', // 切换效果'slide(普通切换、默认)','fade('淡入')','cube(方块)','coverflow(3d流)','flip(3d翻转)'
        fadeEffect: {
          crossFade: true, // 图片渐缩效果
        },
        centeredSlides: true, // 设置活动块居中
        // spaceBetween: "18%", // slide中间的设置距离（单位PX）;
        slidesPerView: 'auto', // 设置slider容器能够同时显示的slides数量
        // loopedSlides: this.images.length + 2, // 设置所要用到的loop个数（一般设置大于可视slide个数2个）
        loop: true,

        coverflowEffect: {
          // coverflow效果参数
          rotate: 0, // slide做3d旋转时Y轴的旋转角度
          stretch: 0, // 每个slide之间的拉伸值，越大slide靠的越紧，5.3.6后可使用百分比%
          depth: 300, // slide的位置深度，值越大Z轴距离越远，看起来越小
          modifier: 1, //
          slideShadows: false, // 是否开启slide阴影
        },
        // 分页器配置
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        // 如果需要前进后退按钮
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        // 如果需要滚动条
        // scrollbar: {
        //   el: ".swiper-scrollbar"
        // }
      })
    },

    // 箭头动画效果
    animationEffect() {
      setInterval(() => {
        this.leftIndex++
        this.rightIndex++
        if (this.leftIndex >= 21 || this.rightIndex >= 21) {
          this.leftIndex = 0
          this.rightIndex = 0
        }
      }, 80);
    },

    onLearnAboutTheEvent(url) {
      let matchUrl = url ? url : ''
      // window.location.href = matchUrl; // 本网页打开外部连接
      // window.open(matchUrl, '_blank') // 新网页打开外部连接
    },
    // 移入了解更多
    onMouseOver() {
      // console.log('移入了')
      this.swiper.autoplay.stop() // 停止轮播
    },
    // 移出了解更多
    onMouseLeave() {
      this.swiper.autoplay.start() // 启动轮播
    },
  },
  updated() {},
  destroyed() {},
  activated() {},
}
</script>
<style lang="scss" scoped>
.home-banner-content {
  background: #ebeafe;
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  font-size: 14px;
  color: #000;
  padding: 0;
  position: relative;
  margin: 80px 0 0 0;
  width: 100%;
  height: calc(100% - 80px);
  //height: 100%;

  .swiper-container {
    width: 100%;
    height: 100%;
    &:hover {
      .swiper-button-prev,
      .swiper-button-next {
        display: block;
      }
    }

    .swiper-wrapper {
      .swiper-slide {
        text-align: center;
        font-size: 18px;
        background: #fff;
        /* Center slide text vertically */
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -webkit-align-items: center;
        align-items: center;
      }
    }

    ::v-deep.swiper-pagination {
      bottom: 68px;
    }

    ::v-deep.swiper-pagination-bullet {
      width: 36px;
      height: 8px;
      display: inline-block;
      border-radius: 4px;
      margin: 0 15px;
      background: #fff;
      opacity: 1;
    }

    ::v-deep .swiper-pagination-bullet-active {
      //background: var(--swiper-pagination-color,var(--swiper-theme-color));
      background: #919ae7;
    }
  }

  .banner-wrap {
    width: 100%;
    height: 100%;
    position: relative;
    margin: 0 auto;

    .banner-bg {
      //position: absolute;
      margin: 0 0 0 0;
      width: 100%;
      height: 100%;
    }

    .banner-content-box {
      width: 1200px;
      position: absolute;
      // top: 245px;
      // top: calc(100vh - 720px);
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .banner-content-title {
        height: 100px;
        color: #FEFEFF;
        font-size: 90px;
        font-family: PangMenZhengDao;
        font-weight: 700;
        letter-spacing: 0.1em;
        text-shadow: 0px 5px 4px #000000;
        line-height: 90px;
      }

      .special-effects {
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 67px 0 52px;
        span {
          color: #FFFFFF;
          font-size: 26px;
          line-height: 47px;
          text-shadow: 0px 5px 4px #000000;
          margin: 0 20px;
        }
        .ul-left {
          height: 100%;
          display: flex;
          flex-direction: row-reverse;
          li {
            width: 22px;
            height: 100%;
            background: url("../../../public/images/home/left-home-decorative01.png") no-repeat;
            background-size: 100% 100%;
            &:nth-child(n+1) {
              margin-left: -10px;
            }
          }
          .li-hover-left {
            background: url("../../../public/images/home/left-home-decorative02.png") no-repeat;
            background-size: 100% 100%;
          }
        }
        .ul-right {
          height: 100%;
          display: flex;
          li {
            width: 22px;
            height: 100%;
            background: url("../../../public/images/home/right-home-decorative01.png") no-repeat;
            background-size: 100% 100%;
            &:nth-child(n+1) {
              margin-right: -10px;
            }
          }
          .li-hover-right {
            background: url("../../../public/images/home/right-home-decorative02.png") no-repeat;
            background-size: 100% 100%;
          }
        }
      }

      .banner-content-ul {
        display: flex;
        justify-content: space-between;
        align-items: center;
        li {
          width: 154px;
          height: 154px;
          position: relative;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          span {
            // width: 120px;
            font-size: 22px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 32px;
          }

          @-webkit-keyframes animalOne {
            0%{
              transform: rotate(-360deg);
              -ms-transform: rotate(-360deg);
              -webkit-transform: rotate(-360deg);
            }
            100%{
              transform: rotate(0deg);
              -ms-transform: rotate(0deg);
              -webkit-transform: rotate(0deg);
            }
          }
          @-webkit-keyframes animalTwo {
            0%{
              transform: rotate(-180deg);
              -ms-transform: rotate(-180deg);
              -webkit-transform: rotate(-180deg);
            }
            100%{
              transform: rotate(180deg);
              -ms-transform: rotate(180deg);
              -webkit-transform: rotate(180deg);
            }
          }
          @-webkit-keyframes animalThree {
            0%{
              transform: rotate(-270deg);
              -ms-transform: rotate(-270deg);
              -webkit-transform: rotate(-270deg);
            }
            100%{
              transform: rotate(90deg);
              -ms-transform: rotate(90deg);
              -webkit-transform: rotate(90deg);
            }
          }
          @-webkit-keyframes animalFour {
            0%{
              transform: rotate(-90deg);
              -ms-transform: rotate(-90deg);
              -webkit-transform: rotate(-90deg);
            }
            100%{
              transform: rotate(270deg);
              -ms-transform: rotate(270deg);
              -webkit-transform: rotate(270deg);
            }
          }
          .icon-ellipse {
            width: 100%;
            height: 100%;
            background: url("../../../public/images/home/ellipse.png") no-repeat;
            background-size: 100% 100%;
            position: absolute;
            top: 0;
            left: 0;
            -webkit-transform-origin: center center;
            -ms-transform-origin: center center;
            transform-origin: center center;
          }
          .icon-ellipse-one {
            -webkit-animation: animalOne 2s infinite linear;
          }
          .icon-ellipse-two {
            -webkit-animation: animalTwo 2s infinite linear;
          }
          .icon-ellipse-three {
            -webkit-animation: animalThree 2s infinite linear;
          }
          .icon-ellipse-four {
            -webkit-animation: animalFour 2s infinite linear;
          }
        }
        .line {
          width: 50px;
          height: 9px;
          background-color: #fff;
        }
      }
    }

    .popover-button {
      width: 1200px;
      // margin: 0 auto;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 75px;
      margin: auto;

      .match-button {
        color: #f4f4f4;
        width: 196px;
        height: 60px;
        background: #1482c8;
        border-radius: 4px;
        font-size: 23px;
        font-family: Microsoft YaHei;
        line-height: 60px;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 206px;
        margin: auto;
        cursor: pointer;
        i {
          margin-left: 20px;
        }
      }

      .more-button {
        width: 136px;
        height: 40px;
        color: #F8F5FF;
        font-size: 16px;
        border: 2px solid #AF90E0;
        border-radius: 23px;
        line-height: 40px;
        position: absolute;
        right: 0;
        bottom: 0;
        z-index: 3;
        cursor: pointer;
        &:hover {
          // color: #4c99ff;
        }
      }
    }
  }

  .swiper-button-prev,
  .swiper-button-next {
    width: 70px;
    height: 70px;
    background-size: 100% 100%;
    display: none;
  }
   
  .swiper-button-prev {
    background: url("../../../public/images/home/icon-left.png") no-repeat;
    margin-left: 100px;
  }
  .swiper-button-next {
    background: url("../../../public/images/home/icon-right.png") no-repeat;
     margin-right: 100px;
  }
}

.el-popover {
  img {
    width: 100%;
  }
  .scanCodeTips {
    width: 100%;
    text-align: center;
  }
}
.swiper-button-next:after, .swiper-container-rtl .swiper-button-prev:after,
.swiper-button-prev:after, .swiper-container-rtl .swiper-button-next:after {
    content: '';
}
</style>
